// Client mirror of functions/yearClosing/taxSpecificationIdentity.ts; test parity.
(function(global: any) {
// Stable specification IDs; legacy display labels are read aliases, never rewritten in bulk.
const taxSpecificationAliases: Record<string, string[]> = {
  "groupContribution": [
    "groupContribution",
    "Koncernbidrag",
    "Konzernbeitrag",
    "Group contribution",
    "Aportación de grupo",
    "Contribution de groupe",
    "Konsernbidrag",
    "Wkład grupowy"
  ],
  "skattefunn": [
    "skattefunn",
    "Forskning og udvikling (skattefunn)",
    "Forschung und Entwicklung (SkatteFUNN)",
    "Research and development (SkatteFUNN)",
    "Investigación y desarrollo (SkatteFUNN)",
    "Recherche et développement (SkatteFUNN)",
    "Forskning og utvikling (skattefunn)",
    "Badania i rozwój (SkatteFUNN)",
    "Forskning och utveckling (skattefunn)"
  ],
  "foreignTaxCredit": [
    "foreignTaxCredit",
    "Fradrag for skat betalt i udlandet",
    "Abzug für im Ausland gezahlte Steuern",
    "Deduction for tax paid abroad",
    "Deducción por impuesto pagado en el extranjero",
    "Déduction de l'impôt payé à l'étranger",
    "Fradrag for skatt betalt i utlandet",
    "Odliczenie podatku zapłaconego za granicą",
    "Avdrag för skatt betald i utlandet"
  ],
  "foreignSubsidiaryTaxCredit": [
    "foreignSubsidiaryTaxCredit",
    "Fradrag for beskatning af udbytte mv. fra udenlandsk datterselskab",
    "Abzug für die Besteuerung von Dividenden usw. einer ausländischen Tochtergesellschaft",
    "Deduction for taxation of dividends etc. from a foreign subsidiary",
    "Deducción por la tributación de dividendos, etc., de una filial extranjera",
    "Déduction au titre de l'imposition des dividendes, etc. d'une filiale étrangère",
    "Fradrag for skattelegging av utbytte mv. fra utenlandsk datterselskap",
    "Odliczenie z tytułu opodatkowania dywidend itp. od zagranicznej spółki zależnej",
    "Avdrag för beskattning av utdelning m.m. från utländskt dotterbolag"
  ],
  "foreignTaxReversal": [
    "foreignTaxReversal",
    "Tilbageført udenlandsk skat i senere år",
    "In späteren Jahren zurückgeführte ausländische Steuer",
    "Foreign tax reversed in a later year",
    "Impuesto extranjero revertido en un año posterior",
    "Impôt étranger reversé au cours d'un exercice ultérieur",
    "Tilbakeført utenlandsk skatt senere år",
    "Zagraniczny podatek zwrócony w późniejszym roku",
    "Återförd utländsk skatt senare år"
  ],
  "stateAid": [
    "stateAid",
    "Modtagelse af skatte- og afgiftsordning omfattet af offentlig støtte",
    "Inanspruchnahme einer Steuer- und Abgabenregelung, die unter staatliche Beihilfen fällt",
    "Receipt of a tax or duty scheme covered by public support",
    "Recepción de un régimen de impuestos o tasas cubierto por ayuda pública",
    "Bénéfice d'un régime fiscal ou de taxes relevant des aides publiques",
    "Mottak av skatte- og avgiftsordning omfattet av offentlig støtte",
    "Korzystanie z ulgi podatkowej lub opłatowej stanowiącej pomoc publiczną",
    "Mottagande av skatte- och avgiftsordning som omfattas av offentligt stöd"
  ]
}
const taxSpecificationId = (value: any): string => Object.keys(taxSpecificationAliases).find(id => taxSpecificationAliases[id].includes(String(value))) || String(value || '')

global.PlummeTaxSpecifications = { aliases: taxSpecificationAliases, id: taxSpecificationId };
})(window);
